import { SSOConfigurationForUi } from '@core/typings/sso-configuration.typing';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class SSOConfigState extends BaseYcState {
  readonly ssoConfig: SSOConfigurationForUi;
}
